import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  getNewsFeedData,
  getNewsTypeGraphInfo,
} from "../../../../store/news/newsSlice";
import { useDispatch } from "react-redux";
import { getUploadConfig } from "../../../../store/config/configSlice";
import { getConfiguredLabel } from "../../../../common/commonHelper";
import { DocumentsPage, newsLimit } from "../../../../common/labelConstants";

import { ComponentLoader } from "../../../loader/componentLoader";

const _props = {
  totalNews: 0,
  sourceName: "",
};
export const LatestNews = (props = _props) => {
  const slbSearchConfig = window.slbConfig;
  const [newsFeedData, setNewsFeedData] = useState([]);
  const [page, setPage] = useState(30);
  // const [totalNews, setTotalNews] = useState(0)
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  let sourceName = props.sourceName;
  let totalLimit = getConfiguredLabel(DocumentsPage, newsLimit);
  const request = {
    clientId: slbSearchConfig.accountId,
    limit: page,
    totalLimit,
    sourceName,
  };
  useEffect(() => {
    if (page <= totalLimit) {
      let promise = dispatch(getNewsFeedData(request));
      promise.then((res) => {
        if (res?.payload?.data) {
          let data = res.payload.data;
          setNewsFeedData([...data]);
          setLoading(false);
        }
      });
      return () => {
        // setIsMounted(false)
        if (promise && typeof promise.abort == "function") promise.abort();
      };
    }
  }, [page, sourceName]);
  // useEffect(() => {
  //     dispatch(getNewsTypeGraphInfo({ template: props.dataListTemplate })).then(res => {
  //         const result = (res?.payload?.data || {})
  //         const total = result.total;
  //         setTotalNews(total)
  //     })
  // }, [])
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 1 >=
      document.documentElement.scrollHeight
    ) {
      setLoading(true);
      setPage((prev) => prev + 20);
    }
  };

  return (
    <div className="row slb_newsData pt-2">
      <div className="d-flex mb-3">
        <div className="newsHeadText">Latest News</div>
        <div className="d-flex ml-4">
          <div className="showingData">
            <span className="showingHead">Showing : </span>
          </div>
          <div className="showingData showingDataLength ml-1">
            <strong> {newsFeedData.length} </strong>
            <strong> {props.totalNews} </strong> Results
          </div>
        </div>
      </div>
      {newsFeedData.length > 0 &&
        newsFeedData.map((data, key) => {
          return (
            <div key={key} className='col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12'>
              <Card>
                <h5>{data.Title}</h5>
                <div className="headBottomLine"></div>
                <p>{data.Summary}</p>
                <div className="sourceDate">
                  <span>
                    {data.PublishDate.split("T")[0]}{" "}
                    <span className="sourceDateDefine"> | </span>{" "}
                  </span>
                  <span className="sourceText">
                    Source :{" "}
                    <a target={"_blank"} href={data.Links}>
                      {data.SourceName}
                    </a>
                  </span>
                </div>
              </Card>
            </div>
          );
        })}
      {page <= totalLimit ? <ComponentLoader /> : null}
    </div>
  );
};
